import { render, staticRenderFns } from "./poster-success.vue?vue&type=template&id=fb1b0e96&scoped=true&"
import script from "./poster-success.vue?vue&type=script&lang=js&"
export * from "./poster-success.vue?vue&type=script&lang=js&"
import style0 from "./poster-success.vue?vue&type=style&index=0&id=fb1b0e96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb1b0e96",
  null
  
)

export default component.exports